import { Component, Input, OnInit } from '@angular/core';
import { ModulesManagerService } from '../../../classes/Module/modules-manager.service';
import { Ask } from '../../../classes/Ask/ask.service';
import { Field } from '../../../classes/Field/field';
import { LoggerService } from '../../../utils/logger.service';
import { SelectorUtils } from '../../../utils/selector-utils';

@Component({
  selector: 'app-selector',
  templateUrl: './selector.page.html',
  styleUrls: ['./selector.page.scss'],
  standalone: false
})
export class SelectorPage implements OnInit {
  private filter = "";
  private _selected = 0;
  private _lowestLevel = 0;
  private opened = false;
  private loading = false;

  //#region Inputs with Custom setter / getter
  @Input()
  get selected(): number {
    return this._selected;
  }
  set selected(value: number) {
    this._selected = value;
    this.manager.Tool.scrollToElementById("#" + this._selected, 500);
    this.resetCache();
  }

  @Input()
  get lowestLevel(): number {
    return this._lowestLevel;
  }
  set lowestLevel(value: number) {
    this._lowestLevel = value;
    this.contents.map(data => data.locked = false);
    this.disableAllOutChilds();
  }
  //#endregion

  @Input() title: string = "";
  @Input() targetField: string = "";
  @Input() contents: Array<{
    value: number;
    label: string;
    locked: boolean;
    fullParentLabel: string;
    parentValue: number;
  }> = [];
  @Input() currentAsk: Ask = null;
  @Input() callBack: any = null;

  private _parent = null;
  private _current = null;
  private _contents = null;

  constructor(public manager: ModulesManagerService) { }

  get Filter() {
    return this.filter;
  }
  set Filter(value) {
    this.filter = value.toLowerCase();
    this.resetCache();
  }

  get TargetField() {
    return this.targetField;
  }

  get Parent() {
    if (!this._parent)
      this._parent = this.contents.find(data => data.value == this.Current?.parentValue);
    return this._parent;
  }

  get Current() {
    if (!this._current)
      this._current = this.contents.find((data) => data.value == this.selected);
    return this._current;
  }

  get fullParentLabel() {
    if (!this.hadChilds && !this.Current?.parentValue) return "";
    if (!this.hadChilds && this.Current?.parentValue) {
      return this.Current.fullParentLabel;
    }
    return (this.Current.fullParentLabel ? this.Current.fullParentLabel + " " : "") + this.Current.label + " /";
  }

  get Css() {
    return this.hadChilds || this.Current?.parentValue ? "margin-left: 38px;width: calc(100% - 38px);" : "";
  }

  get Title() {
    return this.title;
  }

  get Opened() {
    return this.opened;
  }

  get hadChilds() {
    return SelectorUtils.hasChildren(this.contents, this.selected);
  }

  gotChild(content) {
    return SelectorUtils.gotChild(this.contents, content);
  }

  private isVisible(data) {
    return SelectorUtils.isVisible(data, this.currentAsk);
  }

  private disableAllOutChilds(currentLevel = 0) {
    SelectorUtils.disableOutOfHierarchy(this.contents, this.lowestLevel, currentLevel);
  }

  get IsLoading() {
    return this.loading
  }

  get Contents() {
    if (this.loading || !this.opened) return [];
    if (!this._contents) {
      this.loading = true;
      setTimeout(async () => {
        new Promise(async (resolve) => {
          LoggerService.log('Début du chargement des contenus')
          this._contents = SelectorUtils.filterContents(
            this.contents,
            this.filter,
            this.selected,
            this.lowestLevel,
            this.currentAsk
          );
          resolve(true)
        }).then(() => {
          LoggerService.log('Fin du chargement des contenus')
          this.loading = false;
        })
      }, 1)

      return [];
    }
    return this._contents;
  }



  public isSelected(content) {
    return content.value == this.selected;
  }

  public onSelect(content) {
    if (content.locked) return;
    this.filter = "";
    this.selected = content.value;
    this.resetCache();
    if (this.callBack != null) this.callBack(content);
    if (!this.hadChilds) this.manager.closeModal();
  }

  public getBack() {
    this.filter = "";
    const before = this.selected;
    this.selected = (!this.hadChilds && this.Current?.parentValue ? this.contents.find(data => data.value == this.Current?.parentValue)?.parentValue : this.Current?.parentValue) || 0;

    this.resetCache();
    if (this.Current?.locked) {
      this.selected = before;
      this.resetCache();
      return this.callBack({ value: 0 });
    }
    if (this.callBack != null) this.callBack(this.Current ? this.Current : { value: 0 });
  }

  private resetCache() {
    this._current = null;
    this._parent = null;
    this.loading = false
    this._contents = null;
  }


  ngOnInit() { }
  ionViewDidEnter() {
    this.opened = true;

  }

  ionViewWillLeave() {
    this.opened = false;
    this.loading = false
  }
}
